import { Component } from '@angular/core';

/**
 * Generated class for the FormAComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'form-a',
  templateUrl: 'form-a.html'
})
export class FormAComponent {

  text: string;

  constructor() {
    console.log('Hello FormAComponent Component');
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/form-a/form-a.ts